// src/components/Admin/AddEditPlantForm.js

import React, { useState, useEffect } from 'react';
import { addPlant, updatePlant, getPlantCategories } from '../../services/plantService';

function AddEditPlantForm({ plant, onClose }) {
    const [formData, setFormData] = useState({
        name: '',
        botanical_name: '',
        picture_url: '',
        category_id: '',
        description: '',
        is_availability: true,
    });
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        if (plant) {
            setFormData({
                name: plant.name || '',
                botanical_name: plant.botanical_name || '',
                picture_url: plant.picture_url || '',
                category_id: plant.category ? plant.category.category_id : '',
                description: plant.description || '',
                is_availability: plant.is_availability || false,
            });
        }
        fetchCategories();
    }, [plant]);

    const fetchCategories = () => {
        getPlantCategories()
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (plant) {
            // Update existing plant
            updatePlant(plant.plant_id, formData)
                .then(() => {
                    onClose();
                })
                .catch((error) => {
                    console.error(error);
                });
        } else {
            // Add new plant
            addPlant(formData)
                .then(() => {
                    onClose();
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    };

    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
            onClick={onClose}
        >
            <div
                className="bg-white rounded-lg p-6 w-full max-w-md"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="text-2xl font-bold mb-4">
                    {plant ? 'Edit Plant' : 'Add New Plant'}
                </h2>
                <form onSubmit={handleSubmit}>
                    <div className="mb-4">
                        <label className="block text-gray-700">Name</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700">Botanical Name</label>
                        <input
                            type="text"
                            name="botanical_name"
                            value={formData.botanical_name}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700">Picture URL</label>
                        <input
                            type="text"
                            name="picture_url"
                            value={formData.picture_url}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        />
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700">Category</label>
                        <select
                            name="category_id"
                            value={formData.category_id}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                            required
                        >
                            <option value="">Select Category</option>
                            {categories.map((category) => (
                                <option key={category.category_id} value={category.category_id}>
                                    {category.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block text-gray-700">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="w-full border rounded px-3 py-2"
                        ></textarea>
                    </div>
                    <div className="mb-4 flex items-center">
                        <input
                            type="checkbox"
                            name="is_availability"
                            checked={formData.is_availability}
                            onChange={handleChange}
                            className="mr-2"
                        />
                        <label className="text-gray-700">Available</label>
                    </div>
                    <div className="flex justify-end">
                        <button
                            type="button"
                            onClick={onClose}
                            className="mr-4 bg-gray-500 text-white px-4 py-2 rounded hover:bg-gray-600"
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600"
                        >
                            {plant ? 'Update' : 'Add'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default AddEditPlantForm;
